import React, { useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cookingMethodsOptions } from '../../../constants/settings.constants';
import { changeSeveralValues } from '../../../redux/actions/chickenDashAction';
import { SingleSelectFilter } from '../../../components/Filters';

const DashboardToolbarCookingMethod = () => {
  const dispatch = useDispatch();
  const cookingMethod = useSelector(state => state.chickenDashboard.cookingMethod);
  
  const onChange = useCallback((key, val) => {
    dispatch(changeSeveralValues({
      [key]: val,
      chickenTypes: [],
    }));
  }, [dispatch]);
  
  return (
    <SingleSelectFilter
      title="Cooking Method"
      name="cookingMethod"
      options={cookingMethodsOptions}
      value={cookingMethod}
      onChange={onChange}
    />
  );
};

export default memo(DashboardToolbarCookingMethod);